<template>
    <div class="personages-table">
        <table class="control-table control-table--compact">
            <thead class="control-table__head">
                <tr class="control-table__row">
                    <th style="width: 45%" class="control-table__cell">
                        <span v-t="'personages.list.name'" />
                    </th>
                    <th style="width: 35%" class="control-table__cell">
                        <span v-t="'personages.list.speaker'" />
                    </th>
                    <th class="control-table__cell">&nbsp;</th>
                </tr>
            </thead>
            <tbody v-if="personages.length" class="control-table__body">
                <PersonagesCard
                    v-for="personage in personages"
                    ref="personageRes"
                    :key="personage.id"
                    class="control-table__row"
                    :model-value="personage"
                    @personageUpdate="onPersonageUpdate"
                    @personageDelete="onPersonageDelete"
                />
            </tbody>
        </table>
    </div>
</template>

<script>
import PersonagesCard from './PersonagesCard';

export default {
    name: 'PersonagesTable',
    components: {
        PersonagesCard
    },
    props: {
        personages: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onPersonageUpdate(event) {
            this.$emit('personageUpdate', event);
        },
        onPersonageDelete(event) {
            this.$emit('personageDelete', event);
        },
        save() {
            return Promise.all(this.$refs.personageRes.map(res => res.save()));
        }
    }
};
</script>

<style lang="scss" src="./PersonagesTable.scss"></style>
